// extracted by mini-css-extract-plugin
export var barContainer = "_2q-0";
export var extraThin = "_2q-3";
export var fillBar = "_2q-6";
export var fillContainer = "_2q-4";
export var overflow = "_2q-8";
export var overflowContainer = "_2q-5";
export var regular = "_2q-7";
export var thick = "_2q-1";
export var thin = "_2q-2";